import React from 'react'
import { Chart, Geom, Axis, Tooltip, Legend } from 'bizcharts'
import DataSet from '@antv/data-set'

interface ILineChartProps {
  filedsTextMap: object
  data: any[]
}

class LineChart extends React.Component<ILineChartProps> {
  render() {
    const ds = new DataSet()
    const dv = ds.createView().source(this.props.data)
    const legendPosition = 'right-top'
    const { filedsTextMap } = this.props
    dv.transform({
      type: 'fold',
      fields: Object.values(filedsTextMap),
      key: 'months',
      value: 'values',
    })

    return (
      <div>
        <Chart padding={[20, 160, 70, 60]} height={400} data={dv} forceFit>
          <Legend
            textStyle={{
              fontSize: 14,
              fill: '#333',
            }}
            itemMarginBottom={20}
            marker={'square'}
            position={legendPosition}
          />
          <Axis
            name="month"
            label={{
              formatter(text) {
                const arr = text.split('-')
                return `${arr[1]}月\n${arr[0]}`
              },
            }}
          />
          <Axis
            name="values"
            label={{
              formatter: val => val,
            }}
          />
          <Tooltip
            crosshairs={{
              type: 'cross',
            }}
          />
          <Geom type="line" position="month*values" color={'months'} />
          <Geom
            type="point"
            position="month*values"
            size={4}
            shape={'circle'}
            color={'months'}
            style={{
              stroke: '#fff',
              lineWidth: 1,
            }}
          />
        </Chart>
      </div>
    )
  }
}

export default LineChart
